<template>
  <div @click="$event.target.blur()" class="zoom-controls" :style="cssVars">
    <div class="zoom-button-group m-0">
      <b-button-group vertical>
        <b-button
          class="zoom-button"
          :disabled="isMaxZoom"
          variant="light"
          @click="$emit('zoom-in')"
          aria-label="Zoom In"
        >
          <font-awesome-icon icon="plus" class="zoom-control-icon" />
        </b-button>
        <b-button
          class="zoom-button"
          :disabled="isMinZoom"
          variant="light"
          @click="$emit('zoom-out')"
          aria-label="Zoom Out"
        >
          <font-awesome-icon icon="minus" class="zoom-control-icon" />
        </b-button>
      </b-button-group>
    </div>
    <div class="zoom-button-group m-0 mt-1">
      <b-button
        class="zoom-button"
        :disabled="isDefaultView"
        variant="light"
        @click="$emit('reset-view')"
        aria-label="Reset Map View"
      >
        <font-awesome-icon icon="home" class="zoom-control-icon" />
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'zoom-controls',
  props: {
    isMaxZoom: { type: Boolean, required: true },
    isMinZoom: { type: Boolean, required: true },
    isDefaultView: { type: Boolean, required: true },
    showHomeButton: {
      type: Boolean,
      default: true,
    },
    rounded: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    cssVars() {
      if (!this.rounded) {
        return {};
      }
      return `--border-radius: 4px;`;
    },
  },
};
</script>

<style lang="scss" scoped>
.zoom-controls {
  .zoom-button-group {
    background-color: white;
    border-radius: var(--border-radius, 0);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  }

  // it seems that b-button ignores 'width' - so we use min-width/max-width here instead.
  .zoom-button {
    min-width: 40px !important;
    max-width: 40px !important;
    height: 40px !important;
    pointer-events: all;
    background-color: transparent;
    border: none;
    box-shadow: none;

    &:not(:last-child) {
      border-bottom: 1px solid #ebebef !important;
    }
  }

  .zoom-control-icon {
    pointer-events: none;
  }
}
</style>
